import { useCallback, useEffect } from 'react';

const useScrollPosition = (ref, callback) => {
  const handleScroll = useCallback(() => {
    const target = ref ? ref.current : document.body;
    const position = target.getBoundingClientRect();
    callback(position);
  }, [ref, callback]);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, {
      passive: true,
    });

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
};

export default useScrollPosition;
